import { createFileRoute } from '@tanstack/react-router'
import { EventTypeList } from '@/components/events'

export const Route = createFileRoute('/events/event-types/')({
  staticData: {
    title: 'Event Types',
    isSecured: true,
  },
  component: EventTypeList,
})
